export const GRE_PROGRAM_ID = "GRI";
export const TOEFL_PROGRAM_ID = "TEL";
